import { z } from "zod"

/** Problem shape returned by every API error response (RFC 9457 subset). */
export const ApiProblem = z.object({
  type: z.string().default("about:blank"),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  code: z.string().optional(),
  requestId: z.string().optional(),
  errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
})
export type ApiProblem = z.infer<typeof ApiProblem>
